import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function ProductIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect x="17" y="4" width="11" height="11" rx="4" fill={props.fill} />
			<rect x="17" y="17" width="11" height="11" rx="4" fill={props.fill} />
			<rect opacity="0.5" x="4" y="4" width="11" height="11" rx="4" fill={props.fill} />
			<rect x="4" y="17" width="11" height="11" rx="4" fill={props.fill} />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<ProductIcon fill={props.fill} />
		</div>
	);
}